import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { CATEGORIAS_LISTA } from 'constants/codigosTransacciones'

import ListaPage from './lista'

export default function CategoriasPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${CATEGORIAS_LISTA}`} component={ListaPage} />
      </Switch>
    </Suspense>
  )
}
